module.exports = __webpack_public_path__ + "img/643122496026756_thumbnail.jpg";